<template>
  <a-dropdown class="attachable-selectable-table-row"
              :trigger="['contextmenu']">

    <a-menu slot="overlay">
      <a-menu-item key="download" @click="onDownloadClick" v-if="canDownload">
        <download-icon></download-icon>
        Downloaden
      </a-menu-item>
      <a-menu-item key="copy" @click="onCopyClick">
        <content-copy-icon></content-copy-icon>
        Kopieer naar
      </a-menu-item>
      <a-menu-item key="move" @click="onMoveClick">
        <content-cut-icon></content-cut-icon>
        Verplaats naar
      </a-menu-item>
      <a-menu-item key="edit" @click="onEditClick">
        <pencil-icon></pencil-icon>
        Bewerken
      </a-menu-item>
      <a-menu-divider/>
      <a-menu-item key="delete" @click="onDeleteClick">
        <delete-icon></delete-icon>
        Verwijderen
      </a-menu-item>
    </a-menu>

    <tr v-on:click="onSelectionChanged" v-bind:class="{selected: selected}">
      <td class="compact half-padding">
        <a-checkbox
            ref="checkbox"
            :checked="selected"
            @change="onSelectionChanged"
            v-on:click.stop
        ></a-checkbox>
      </td>
      <td>
        <template v-if="editing">
          <a-input-group>
            <a-input ref="isAttachableNameInput"
                     v-model="isAttachableName"
                     v-on:click.stop
                     v-on:keyup.enter="onSave"
                     v-on:keyup.esc="onCancel"
                     v-bind:disabled="updatingIsAttachableName"
                     style="width: 80%;"
            ></a-input>
            <a-button :loading="updatingIsAttachableName" v-on:click.stop="onSave">
              <content-save-icon></content-save-icon>
            </a-button>
          </a-input-group>
        </template>
        <template v-else>
          <AttachableBreadcrumbs v-if="showBreadcrumbs && hasBreadcrumbs"
                                 :breadcrumbs="breadcrumbs"></AttachableBreadcrumbs>
          <AttachableTypeComponent :attachable="attachable"></AttachableTypeComponent>

          <a-popover v-if="isMsgFile" placement="top">
            <template slot="content">
              <a :href="childInstance.show_link" target="_blank" v-if="canShow">
                Bestand bekijken
              </a>
              <br>
              <a :href="documentDownloadUrl" target="_blank">
                Bestand downloaden
              </a>
            </template>
            {{ name }}
            <ShowProductLabelComponent v-for="(productLabel, i) in productLabels" :key="i"
                                       :product-label="productLabel"></ShowProductLabelComponent>
          </a-popover>
          <span v-else>
            <a :href="showLink" :target="target" v-on:click.stop v-if="canShow">
            {{ name }}
            </a>
            <span v-else>
             {{ name }}
            </span>
            <ShowProductLabelComponent v-for="(productLabel, i) in productLabels" :key="i"
                                     :product-label="productLabel"></ShowProductLabelComponent>
          </span>

        </template>
      </td>
      <td class="compact">
        {{ date }}
      </td>
      <td class="compact">
        <HumanFilesizeComponent :bytes="size"></HumanFilesizeComponent>
      </td>
      <td class="compact" v-if="hasCustomer">
        <eye-icon v-if="attachable.visible_for_customer" style="color: #6dc287;"></eye-icon>
        <eye-off-icon v-if="!attachable.visible_for_customer" style="color: #a2a2a2;"></eye-off-icon>
      </td>
      <td class="compact" v-if="!hasCustomer">
        <eye-icon v-if="attachable.is_public" style="color: #6dc287;"></eye-icon>
        <eye-off-icon v-if="!attachable.is_public" style="color: #a2a2a2;"></eye-off-icon>
      </td>
      <td class="compact">
        <a-dropdown class="actions" :trigger="['click']" v-on:click.stop placement="bottomRight">
          <a-button type="default" @click.stop="e => e.preventDefault()">
            Acties
            <a-icon type="down"/>
          </a-button>

          <a-menu slot="overlay">
            <a-menu-item key="download" class="action-download" @click="onDownloadClick" v-if="canDownload">
              <download-icon></download-icon>
              Downloaden
            </a-menu-item>
            <a-menu-item key="copy" class="action-copy" @click="onCopyClick">
              <content-copy-icon></content-copy-icon>
              Kopieer naar
            </a-menu-item>
            <a-menu-item key="move" class="action-move" @click="onMoveClick">
              <content-cut-icon></content-cut-icon>
              Verplaats naar
            </a-menu-item>
            <a-menu-item key="edit" class="action-edit" @click="onEditClick">
              <pencil-icon></pencil-icon>
              Bewerken
            </a-menu-item>
            <a-menu-item key="publish-toggle" class="action-publish-toggle" v-if="publishDocuments && hasCustomer"
                         @click="onPublishForCustomerToggleClick">
              <span v-if="!attachable.visible_for_customer">
                <eye-icon></eye-icon> Publiceren
              </span>
              <span v-if="attachable.visible_for_customer">
                <eye-off-icon></eye-off-icon> Onpubliceren
              </span>
            </a-menu-item>
            <a-menu-item key="publish-toggle" class="action-publish-toggle" v-else-if="publishDocuments && !hasCustomer"
                         @click="onPublishToggleClick">
              <span v-if="!attachable.is_public">
                <eye-icon></eye-icon> Publiceren
              </span>
              <span v-if="attachable.is_public">
                <eye-off-icon></eye-off-icon> Onpubliceren
              </span>
            </a-menu-item>
            <a-menu-divider/>
            <a-menu-item key="delete" class="action-delete" @click="onDeleteClick">
              <delete-icon></delete-icon>
              Verwijderen
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </td>
    </tr>
  </a-dropdown>
</template>

<script>
import {mapGetters} from "vuex";
import attachableCategoryStore from '../../attachable_category/store';
import isAttachableApi from '~/api/isAttachable';
import AttachableBreadcrumbs from "./Breadcrumbs";
import AttachableTypeComponent from "~/components/FileTypeIconComponent";
import AttachableMenuComponent from "./MenuComponent";
import BadgeComponent from '~/modules/customer/components/BadgeComponent';
import HumanFilesizeComponent from '~/components/HumanFilesizeComponent';
import ShowProductLabelComponent from "~/modules/product_label/components/ShowProductLabelComponent";
import FileTypeIconComponent from "~/components/FileTypeIconComponent.vue";

const moment = require('moment');

export default {
  name: "AttachableSelectableTableRowComponent",
  props: {
    attachable: {
      type: Object,
      required: true
    },
    showBreadcrumbs: {
      type: Boolean,
      required: false,
      default: false
    },
    publishDocuments: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    FileTypeIconComponent,
    ShowProductLabelComponent,
    AttachableBreadcrumbs,
    AttachableTypeComponent,
    AttachableMenuComponent,
    BadgeComponent,
    HumanFilesizeComponent
  },
  data() {
    return {
      editing: false,
      showMoveModal: false,
      updatingIsAttachableName: false,
      isAttachableName: this.attachable.child_instance.data.name
      // processLoading: false,
      // unmatchLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedAttachables: '$_attachable_category/selectedAttachables',
    }),
    documentDownloadUrl() {
      return this.route('document.download', [this.childInstance.id]);
    },
    hasBreadcrumbs() {
      return typeof this.attachable.child_instance !== "undefined"
          && this.attachable.child_instance !== null
          && typeof this.attachable.child_instance.data !== "undefined"
          && this.attachable.child_instance.data !== null
          && typeof this.attachable.child_instance.data.breadcrumbs !== "undefined"
          && this.attachable.child_instance.data.breadcrumbs !== null
          && typeof this.attachable.child_instance.data.breadcrumbs.data !== "undefined"
          && this.attachable.child_instance.data.breadcrumbs.data !== null;
    },
    breadcrumbs() {
      if (this.hasBreadcrumbs) {
        return this.attachable.child_instance.data.breadcrumbs.data;
      }

      return null;
    },
    selected() {
      return this.selectedAttachables.findIndex(x => x.id === this.attachable.id) >= 0;
    },
    hasCustomer() {
      return this.attachable.customer_id !== null;
    },
    childInstance() {
      return this.attachable.child_instance.data;
    },
    name() {
      return this.childInstance.name;
    },
    date() {
      return moment(this.childInstance.date, moment.ISO_8601).format('D/MM/YYYY HH:mm:ss');
    },
    size() {
      return this.childInstance.size;
    },
    canShow() {
      return typeof this.childInstance.show_link !== "undefined";
    },
    showLink() {
      return this.childInstance.show_link;
    },
    // canEdit() {
    //   return true;
    //   return typeof this.childInstance.edit_link !== "undefined";
    // },
    // editLink() {
    //   return this.childInstance.edit_link;
    // },
    canDownload() {
      return true;
    },
    target() {
      if (this.attachable.child_class === "email" || this.attachable.child_class === "note" || (this.attachable.child_class === "document" && this.attachable.child_instance.data.extension === "mime")) {
        return '_self';
      } else {
        return '_blank';
      }
    },
    hasProductLabels() {
      if (typeof this.childInstance !== 'undefined' && this.childInstance !== null &&
          typeof this.childInstance.product_labels !== 'undefined' && this.childInstance.product_labels !== null) {
        return this.attachable.child_instance.data.product_labels.data.length > 0;
      }
      return false;
    },
    productLabels() {
      if (this.hasProductLabels) {
        return this.childInstance.product_labels.data;
      }
      return [];
    },
    isMsgFile() {
      return this.childInstance.extension === 'msg';
    }
  },
  created() {
    const STORE_KEY = '$_attachable_category';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, attachableCategoryStore);
    }
  },
  methods: {
    onSave() {
      this.updatingIsAttachableName = true;
      isAttachableApi.updateByAttachable(this.attachable.id, {
        name: this.isAttachableName,
      }).then((response) => {
        this.editing = false;
        this.childInstance.name = this.isAttachableName;
        this.$emit('updated', this.attachable);
      }).catch((error) => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Er is iets fout gegeaan tijdens het wijzigen van de naam',
        });
      }).finally(() => {
        this.updatingIsAttachableName = false;
      });
    },
    onCancel() {
      this.editing = false;
    },
    onSelectionChanged(e) {
      let shiftKey = false;

      if (typeof e.shiftKey !== "undefined") {
        shiftKey = e.shiftKey;
      }

      this.$emit('selection-changed', this.attachable, !this.selected, shiftKey);
    },
    onDownloadClick() {
      this.$emit('download', this.attachable);
    },
    onCopyClick() {
      this.$emit('copy', this.attachable);
    },
    onMoveClick() {
      this.$emit('move', this.attachable);
    },
    onDeleteClick() {
      this.$emit('delete', this.attachable);
    },
    onPublishForCustomerToggleClick() {
      this.attachable.visible_for_customer = !this.attachable.visible_for_customer;
      this.$emit('update', this.attachable);
    },
    onPublishToggleClick() {
      this.attachable.is_public = !this.attachable.is_public;
      this.$emit('update', this.attachable);
    },
    onEditClick(e) {
      this.editing = true;
    },
  }
}
</script>

<style scoped>
tr td.half-padding {
  padding: 4px;
}

table tr.attachable-selectable-table-row td {
  vertical-align: middle !important;
}

tr.selected {
  background-color: #1890ff1c !important;
}

tr.selected > td {
  border-top: solid 1px #ffffff85;
}

tr.selected a {
  font-weight: 400;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

tr .pencil-icon {
  display: none;
}

tr:hover .pencil-icon {
  display: initial;
}
</style>
